import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Collapse, Button, Icon, Radio, Checkbox, Input, Pagination, FormModel, Upload, Modal, Progress, Menu, ConfigProvider, Table } from "ant-design-vue";
import { Loading, Tooltip, MessageBox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

//富文本编辑器组件
import VueQuillEditor from "vue-quill-editor/src";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//分片上传组件
import webuploader from "webuploader"//分片上传
window.webuploader = webuploader;

// echarts
import * as echarts from 'echarts'

Vue.use(VueQuillEditor);
Vue.use(Collapse);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Input);
Vue.use(Pagination);
Vue.use(FormModel);
Vue.use(Modal);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Menu);
Vue.use(ConfigProvider);
Vue.use(Table);
Vue.use(Tooltip)
Vue.use(Loading)
Vue.component(MessageBox);
Vue.prototype.$alert = MessageBox.alert
Vue.config.productionTip = false
import 'element-ui/'
import 'swiper/swiper.min.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

// 封装全局loading
let loading = null;
const openLoading = obj => {
  loading = Loading.service({
    lock: obj ? obj.lock ? obj.lock : true : true,
    text: obj ? obj.text ? obj.text : '正在加载...' : '正在加载...',
    spinner: obj ? obj.spinner ? obj.spinner : 'el-icon-loading' : 'el-icon-loading',
    background: obj ? obj.background ? obj.background : 'rgba(255, 255, 255, 0.6)' : 'rgba(255, 255, 255, 0.6)'
  });
  return true;
}
const closeLoading = () => {
  if (loading) {
    loading.close();
    loading = null;
  }
}

//注入全局属性$message
import { message, notification } from 'ant-design-vue'
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
// 注入全局属性$openLoading,$closeLoading
Vue.prototype.$openLoading = openLoading;
Vue.prototype.$closeLoading = closeLoading;
message.config({
  duration: 2,// 持续时间
  top: `45%`, // 到页面顶部距离
  maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
})
// 注入echarts
Vue.prototype.$echarts = echarts


// console.log(2, VueCookies);
// console.log('this.$cookies', this.$cookies);
const app = new Vue({
  router,
  store,
  render: h => h(App)
})

window.onload = function () {
  app.$mount('#app')
}

export {
  loading,
  openLoading,
  closeLoading,
}
